import * as React from "react"

const HighLightDownSVG = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={12} height={7} fill="none" {...props}>
		<path
			fill="#475163"
			fillOpacity={1}
			d="M11.3.3a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7L6.7 6.3c-.1.1-.208.17-.325.212A1.132 1.132 0 0 1 6 6.575c-.133 0-.263-.025-.388-.075a.905.905 0 0 1-.312-.2L.7 1.7A.948.948 0 0 1 .425 1C.425.717.517.483.7.3a.948.948 0 0 1 .7-.275c.283 0 .517.092.7.275L6 4.2 9.9.3a.948.948 0 0 1 .7-.275c.283 0 .517.092.7.275Z"
		/>
	</svg>
)

export default HighLightDownSVG
